import React from 'react'
import View from './view'

const CommunitiesManage = ({ ...props }) => {
    return <View {...props} />
}

export default CommunitiesManage
